import { DateTime } from 'luxon';
import { ISO8601TupleType } from 'types/common.types';
import {
  DatePresetConfig,
  DatePresetKey,
} from 'pages/ReportsPage/store/analyticsFilter.store.types';

const toISO = (date: Date): string => DateTime.fromJSDate(date).toString();

const startOfDay = (date: Date): Date => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

const endOfDay = (date: Date): Date => {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
};

export const DATE_PRESETS: DatePresetConfig[] = [
  {
    key: '3_DAYS',
    label: 'reports:3_DAYS',
    getRange: (): ISO8601TupleType => {
      const today = endOfDay(new Date());
      const start = startOfDay(new Date());
      start.setDate(start.getDate() - 2);
      return [toISO(start), toISO(today)];
    },
  },
  {
    key: '7_DAYS',
    label: 'reports:7_DAYS',
    getRange: (): ISO8601TupleType => {
      const today = endOfDay(new Date());
      const start = startOfDay(new Date());
      start.setDate(start.getDate() - 6);
      return [toISO(start), toISO(today)];
    },
  },
  {
    key: '14_DAYS',
    label: 'reports:14_DAYS',
    getRange: (): ISO8601TupleType => {
      const today = endOfDay(new Date());
      const start = startOfDay(new Date());
      start.setDate(start.getDate() - 13);
      return [toISO(start), toISO(today)];
    },
  },
  {
    key: '30_DAYS',
    label: 'reports:30_DAYS',
    getRange: (): ISO8601TupleType => {
      const today = endOfDay(new Date());
      const start = startOfDay(new Date());
      start.setDate(start.getDate() - 29);
      return [toISO(start), toISO(today)];
    },
  },
  // {
  //   key: 'THIS_MONTH',
  //   label: 'reports:THIS_MONTH',
  //   getRange: (): ISO8601TupleType => {
  //     const today = endOfDay(new Date());
  //     const start = startOfDay(new Date());
  //     start.setDate(1);
  //     return [toISO(start), toISO(today)];
  //   },
  // },
  // {
  //   key: 'LAST_MONTH',
  //   label: 'reports:LAST_MONTH',
  //   getRange: (): ISO8601TupleType => {
  //     const now = new Date();
  //     const start = startOfDay(new Date(now.getFullYear(), now.getMonth() - 1, 1));
  //     const end = endOfDay(new Date(now.getFullYear(), now.getMonth(), 0));
  //     return [toISO(start), toISO(end)];
  //   },
  // },
];

export const DEFAULT_DATE_PRESET: DatePresetKey = '7_DAYS';

export const getDefaultDateRange = (): ISO8601TupleType => {
  const preset = DATE_PRESETS.find((p) => p.key === DEFAULT_DATE_PRESET);
  return preset!.getRange();
};

export const isoToISOStart = (iso: string): string => toISO(startOfDay(new Date(iso)));

export const isoToISOEnd = (iso: string): string => toISO(endOfDay(new Date(iso)));

export const CUSTOM_DATE_RANGE_MAX_YEARS = 2;

export const getMinCustomDate = (): string =>
  DateTime.now().startOf('day').minus({ years: CUSTOM_DATE_RANGE_MAX_YEARS }).toString();
